
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 12.999c0-3.057-2.874-5.582-6.572-5.949l-.301-1.708C16.01 2.146 12.643 0 8.75 0 3.924 0 0 3.364 0 7.5c0 2.22 1.119 4.279 3.086 5.709l-1.033 2.067a.501.501 0 00.693.658l2.646-1.512c.701.249 1.449.42 2.257.51l1.788.065c1.032 2.328 3.804 4.002 7.063 4.002a9.19 9.19 0 002.297-.292l2.479 1.24a.501.501 0 00.688-.633l-.679-1.699C22.993 16.481 24 14.782 24 12.999zm-16.274.937a8.937 8.937 0 01-2.197-.531.51.51 0 00-.428.033l-1.415.809.489-.979a.5.5 0 00-.174-.642C2.094 11.38 1 9.512 1 7.5 1 3.916 4.477 1 8.75 1c3.415 0 6.472 1.922 7.413 4.592l.244 1.411C12.314 7.044 9 9.716 9 12.999c0 .337.043.665.11.987l-1.384-.05zm12.688 3.045a.498.498 0 00-.212.617l.346.866-1.473-.736a.505.505 0 00-.358-.034 8.193 8.193 0 01-2.215.306c-3.584 0-6.5-2.243-6.5-5s2.916-5 6.5-5 6.5 2.243 6.5 5c0 1.57-.943 3.022-2.588 3.981z"}})])
          )
        }
      }
    